import { render, staticRenderFns } from "./Iaf.vue?vue&type=template&id=39a3b124&scoped=true"
import script from "./Iaf.vue?vue&type=script&lang=js"
export * from "./Iaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a3b124",
  null
  
)

export default component.exports